import React from "react";
import { useReadOnly } from "../../../utils/ReadOnlyContext";
import './Radio.css'

interface RadioProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    forceenabled?: boolean;
}

export default function Radio(props: RadioProps): JSX.Element {
    const { isReadOnly } = useReadOnly()
    return (
        <label className={"radio-container"}
            tabIndex={0}
            aria-label={props.name ? props.name : props.id}
            onKeyUp={(e) => {
                if (e.key === " ") {
                    (e.target as HTMLElement).click()
                }
            }}
        >
            <input {...props}
                type="radio"
                tabIndex={-1}
                disabled={props.forceenabled ? false : isReadOnly || props.readOnly || props.disabled}
                aria-label={props.name ? props.name : props.id}
                onChange={(e) => {
                    if (props.onChange) {
                        props.onChange(e)
                    }
                }}
            />
            <span className={"radiomark"} tabIndex={-1}></span>
        </label>
    )
}
